<!-- Proforma Preview Modal -->
<div class="modal fade" id="kt_modal_proforma_preview" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content position-relative">
      <!-- Loading Overlay -->
      <div *ngIf="isGeneratingPDF" class="pdf-loading-overlay position-absolute w-100 h-100 d-flex align-items-center justify-content-center" style="z-index: 9999; background-color: rgba(255, 255, 255, 0.95); top: 0; left: 0; border-radius: 0.5rem;">
        <div class="text-center">
          <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;">
            <span class="visually-hidden">Loading...</span>
          </div>
          <h5 class="text-primary mb-2">Generating PDF...</h5>
          <p class="text-muted mb-0">Please wait while we create your proforma document</p>
        </div>
      </div>

      <!-- Modal Header -->
      <div class="modal-header pb-0 border-0 justify-content-end">
        <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <!-- Modal Body -->
      <div class="modal-body px-lg-10 pb-lg-10">
        <!-- Proforma Document -->
        <div id="proforma-document-content" class="proforma-document bg-white" style="font-family: Arial, sans-serif; font-size: 12px; line-height: 1.4;">

          <!-- Header Section -->
          <div class="d-flex justify-content-between align-items-start mb-4">
            <!-- Company Logo and Info -->
            <div class="d-flex align-items-center">
              <div class="company-logo me-4 bg-black">
                <img alt="Logo" src="/assets/media/logos/default-dark.svg" style="height: 80px; width: auto; max-width: 120px;">
              </div>
              <!-- <div>
                <h2 class="text-primary fw-bold mb-1" style="font-size: 24px;">Imperial Solutions</h2>
                <p class="text-muted mb-0 fw-bold" style="font-size: 14px;">PROSPERITY FOR ALL</p>
              </div> -->
            </div>

            <!-- Company Address -->
            <div class="text-end">
              <p class="mb-0 fw-bold">IMPERIAL SOLUTIONS LTD.</p>
              <p class="mb-0">22-14 AOBADAI, KITA-KU, KOBE, JAPAN</p>
              <p class="mb-0">PHONE: +81-78-291-5360 FAX: +81-78-291-5374</p>
              <p class="mb-0">E-MAIL: isl@imperialsolutions.jp</p>
            </div>
          </div>

          <!-- Proforma Invoice Title -->
          <div class="text-center mb-4">
            <h3 class="fw-bold" style="font-size: 18px; letter-spacing: 2px;">PROFORMA INVOICE</h3>
          </div>

          <!-- Main Content Table -->
          <table class="table table-bordered" style="border: 2px solid #000;">
            <tbody>
              <!-- First Row: Consignee and Proforma Details -->
              <tr>
                <td class="p-3" style="width: 50%; border-right: 2px solid #000;">
                  <div>
                    <p class="mb-2 fw-bold">Consignee</p>
                    <p class="mb-1 fw-bold">{{ selectedProforma?.buyer_consignee_name || 'LevelTen Autos' }}</p>
                    <p class="mb-1">{{ selectedProforma?.buyer_street_address || 'Mt. Rose, St. Patrick' }}</p>
                    <p class="mb-1">{{ selectedProforma?.buyer_city || 'ST. Georges, Grenada' }}</p>
                    <p class="mb-1">{{ selectedProforma?.buyer_email_address || 'kadedecoteau@hotmail.com' }}</p>
                    <p class="mb-0">TEL 1: {{ selectedProforma?.buyer_telephone_no || '1(473)416 9463' }}</p>
                  </div>
                </td>
                <td class="p-3" style="width: 50%;">
                  <div class="row">
                    <div class="col-6">
                      <p class="mb-1">Proforma No</p>
                      <p class="mb-3 fw-bold">{{ selectedProforma?.order_number || 'P-19138' }}</p>

                      <p class="mb-1 fw-bold">Bank Account Details</p>
                      <p class="mb-1"><span class="fw-bold">Bank Name:</span> MIZUHO BANK LTD</p>
                      <p class="mb-1"><span class="fw-bold">Branch Name:</span> KOBE BRANCH</p>
                      <p class="mb-1"><span class="fw-bold">Account Name:</span> IMPERIAL SOLUTIONS LTD.</p>
                      <p class="mb-1"><span class="fw-bold">Account Number:</span> 490 0103234</p>
                      <p class="mb-1"><span class="fw-bold">Swift Code:</span> MHCBJPJT</p>
                      <p class="mb-0"><span class="fw-bold">Branch Address:</span> Hyogo Ken, Kobe-shi, Chuo-ku, Sannomiya-cho, 1-3-1 650-0021</p>
                    </div>
                    <div class="col-6">
                      <p class="mb-1">Date</p>
                      <p class="mb-3 fw-bold">{{ (selectedProforma && selectedProforma.order_date) ? formatDate(selectedProforma.order_date) : '16th Sep, 2025' }}</p>
                    </div>
                  </div>
                </td>
              </tr>

              <!-- Second Row: Port and Payment Details -->
              <tr>
                <td class="p-3" style="border-right: 2px solid #000;">
                  <div class="row">
                    <div class="col-6">
                      <p class="mb-1 fw-bold">Port of Loading</p>
                      <p class="mb-0">{{ selectedProforma?.from_port || 'Kobe, Japan' }}</p>
                    </div>
                    <div class="col-6">
                      <p class="mb-1 fw-bold">Port of Discharging</p>
                      <p class="mb-0">{{ selectedProforma?.to_port || 'St. Georges, Grenada' }}</p>
                    </div>
                  </div>
                </td>
                <td class="p-3">
                  <div class="row">
                    <div class="col-6">
                      <p class="mb-1 fw-bold">Payment Terms</p>
                      <p class="mb-0">{{ selectedProforma?.payment_terms || 'C&F, Grenada' }}</p>
                    </div>
                    <div class="col-6">
                      <p class="mb-1 fw-bold">Trade Terms</p>
                      <p class="mb-0">C&F, Grenada</p>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Vehicle Details Section -->
          <table class="table table-bordered mt-3" style="border: 2px solid #000;">
            <thead>
              <tr style="background-color: #f8f9fa;">
                <th class="p-2 text-center fw-bold" style="width: 15%; border-right: 1px solid #000;">Image</th>
                <th class="p-2 text-center fw-bold" style="width: 35%; border-right: 1px solid #000;">Vehicle Details</th>
                <th class="p-2 text-center fw-bold" style="width: 35%; border-right: 1px solid #000;">Cost Calculation [USD]</th>
                <th class="p-2 text-center fw-bold" style="width: 15%;">1 Unit Price</th>
              </tr>
            </thead>
            <tbody>
              <!-- Loop through all vehicles -->
              <tr *ngFor="let vehicle of selectedProforma?.vehicles; let i = index; trackBy: trackByVehicleId">
                <td class="p-2 text-center" style="border-right: 1px solid #000;">
                  <div class="vehicle-image d-flex align-items-center justify-content-center" style="width: 80px; height: 60px; margin: 0 auto;">
                    <img
                      [src]="getVehicleImage(vehicle)"
                      [alt]="vehicle.name + ' Image'"
                      class="rounded"
                      style="width: 100%; height: 100%; object-fit: cover;"
                      (error)="$any($event.target).src='assets/media/stock/600x400/img-1.jpg'">
                  </div>
                </td>
                <td class="p-2" style="border-right: 1px solid #000;">
                  <div>
                    <p class="mb-1 fw-bold">{{ vehicle.maker_name || 'Suzuki' }} {{ vehicle.name || 'IGNIS' }} {{ vehicle.year || '2016/7' }}</p>
                    <p class="mb-1"><span class="fw-bold">Chassis No:</span> {{ vehicle.chassis_no || 'FF21S-115945' }}</p>
                    <p class="mb-1"><span class="fw-bold">Mileage:</span> {{ vehicle.mileage || '64,000' }} KM</p>
                    <p class="mb-1"><span class="fw-bold">Steering:</span> {{ vehicle.steering || 'Right Hand' }}</p>
                    <p class="mb-0"><span class="fw-bold">Mfg Year/Month:</span> {{ vehicle.year || '2016' }}</p>
                  </div>
                </td>
                <td class="p-2" style="border-right: 1px solid #000;">
                  <div>
                    <p class="mb-1"><span class="fw-bold">Model Code:</span> {{ vehicle.model || 'DAA-FF21S' }}</p>
                    <p class="mb-1"><span class="fw-bold">Fuel:</span> {{ vehicle.fuel_type || 'Gasoline/Hybrid' }}</p>
                    <p class="mb-1"><span class="fw-bold">Engine CC:</span> {{ vehicle.engine || '1,240 CC' }}</p>
                    <p class="mb-0"><span class="fw-bold">Steering:</span> {{ vehicle.steering || 'Right Hand' }}</p>
                  </div>
                </td>
                <td class="p-2 text-center">
                  <p class="mb-0 fw-bold">{{ getIndividualVehiclePrice(i) || '5,000' }}</p>
                </td>
              </tr>

              <!-- Show fallback data when no vehicles are available -->
              <tr *ngIf="getVehicleCount() === 0">
                <td class="p-2 text-center" style="border-right: 1px solid #000;">
                  <div class="vehicle-image bg-secondary d-flex align-items-center justify-content-center" style="width: 80px; height: 60px; margin: 0 auto;">
                    <span class="text-white small">No Image</span>
                  </div>
                </td>
                <td class="p-2" style="border-right: 1px solid #000;">
                  <p class="mb-1 fw-bold">Suzuki IGNIS 2016/7</p>
                  <p class="mb-1"><span class="fw-bold">Chassis No:</span> FF21S-115945</p>
                  <p class="mb-1"><span class="fw-bold">Mileage:</span> 64,000 KM</p>
                  <p class="mb-1"><span class="fw-bold">Steering:</span> Right Hand</p>
                  <p class="mb-0"><span class="fw-bold">Mfg Year/Month:</span> 2016</p>
                </td>
                <td class="p-2" style="border-right: 1px solid #000;">
                  <p class="mb-1"><span class="fw-bold">Model Code:</span> DAA-FF21S</p>
                  <p class="mb-1"><span class="fw-bold">Fuel:</span> Gasoline/Hybrid</p>
                  <p class="mb-1"><span class="fw-bold">Engine CC:</span> 1,240 CC</p>
                  <p class="mb-0"><span class="fw-bold">Steering:</span> Right Hand</p>
                </td>
                <td class="p-2 text-center">
                  <p class="mb-0 fw-bold">5,000</p>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Options Section -->
          <div class="mt-2">
            <p class="mb-2"><span class="fw-bold">Options:</span> Power Windows, Air Bag, Fog Lamp, Rear Spoiler, ABS, Alloy Wheels, AC, Push Start, Seat Heater, Winker Mirror, AC PS</p>
          </div>

          <!-- Total Section -->
          <table class="table table-bordered mt-3" style="border: 2px solid #000;">
            <tbody>
              <tr>
                <td class="p-2 text-center fw-bold" style="width: 70%; border-right: 1px solid #000;">
                  Total {{ getDisplayVehicleCount() }} Unit(s) C&F {{ selectedProforma?.to_port || 'St. Georges, Grenada' }}
                </td>
                <td class="p-2 text-center fw-bold" style="width: 15%; border-right: 1px solid #000;">
                  Total
                </td>
                <td class="p-2 text-center fw-bold" style="width: 15%;">
                  {{ getTotalAmount() || '5,000' }}
                </td>
              </tr>
              <tr>
                <td class="p-2" style="border-right: 1px solid #000;"></td>
                <td class="p-2 text-center fw-bold" style="border-right: 1px solid #000;">
                  Total C&F
                </td>
                <td class="p-2 text-center fw-bold">
                  {{ getTotalAmount() || '5,000' }}
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Due Date and Notes Section -->
          <div class="mt-4">
            <div class="row">
              <div class="col-8">
                <p class="mb-2"><span class="fw-bold">Due Date *</span> --</p>
                <p class="mb-2"><span class="fw-bold">Note:</span></p>
                <p class="mb-2">PLEASE INCLUDE PROFORMA NUMBER IN THE REMITTANCE INFORMATION SECTION WHEN MAKING YOUR PAYMENT</p>
                <p class="mb-3">WE CERTIFY THAT THE GOODS ARE OF JAPANESE ORIGIN</p>
                <p class="mb-2">The Buyer should bear the cost of Bank Charge when remitting T/T.</p>
                <p class="mb-2">The Buyer is purchasing a reconditioned vehicle.</p>
                <p class="mb-0">Minor issues such as weak battery, lack of engine/transmission oil, and worn out tyres should be fixed by the Buyer or the transport company/agent before moving the vehicle from port to the final destination.</p>
              </div>
              <div class="col-4 text-end">
                <!-- Stamp/Seal Area -->
                <div class="d-flex justify-content-end mb-3">
                  <div class="border border-2 border-danger p-3 text-center" style="width: 120px; height: 80px; transform: rotate(-15deg);">
                    <p class="mb-0 text-danger fw-bold small">IMPERIAL</p>
                    <p class="mb-0 text-danger fw-bold small">SOLUTIONS</p>
                  </div>
                </div>

                <!-- Signature Section -->
                <div class="text-center">
                  <p class="mb-2 fw-bold">Authorized Signature</p>
                  <div class="signature-area mb-2" style="font-family: cursive; font-size: 18px; font-weight: bold;">
                    Imperial Solutions
                  </div>
                  <p class="mb-0 fw-bold">D.S.SETHI</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer border-0 pt-0">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" (click)="printProforma()">
          <i class="ki-duotone ki-printer fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
            <span class="path3"></span>
          </i>
          Print
        </button>
      </div>
    </div>
  </div>
</div>
